import React from "react";
import CustomTable from "../../utils/commonComponent/CustomAntTable";
import { Button } from "react-bootstrap";
import { connect } from "react-redux";
import { BaseReactComponent } from "../../utils/form";
import { API_LIMIT, MODULE_ID_MAP, START_PAGE, isModuleExist } from "../../utils/Constant";
import { ComponentHeader, InformationModal, Spinner } from "../common";
import { deleteCustomerApi, getCustomerNameApi } from "./Api";
import { replaceHistory } from "../../utils/ReusableFunctions";
import moment from "moment";
import { withRouter } from "../../utils/hoc/withRouter";
import OptionsDropdown from "../../utils/commonComponent/OptionsDropdown";
class Customers extends BaseReactComponent {
  constructor(props) {
    super(props);
    const access = isModuleExist(MODULE_ID_MAP.WebUsersWebUsersList);
    this.state = {
      access,
      search: "",
      dummyData: [],
      searchResult: [],
      pageSize: API_LIMIT,
      currentPage: START_PAGE,
      delete: false,
      deleteData: {},
      editData: "",
      showEdit: false,
      detailLoading: false,
    };
  }

  componentDidMount() {
    const { history } = this.props;
    history({
      pathname: this.props.location.pathname,
      search: `?p=${this.state.currentPage || START_PAGE}`,
    });
    this.props.getCustomerNameApi(this);
  }

  componentDidUpdate(prevProps, prevState) {
    const prevParams = new URLSearchParams(prevProps.location.search);
    const prevPage = parseInt(prevParams.get("page"), 10) || START_PAGE;
    const prevSearch = prevParams.get("search") || "";
    const prevSize = prevParams.get("pageSize") || "";

    const params = new URLSearchParams(this.props.location.search);
    const page = parseInt(params.get("page"), 10) || START_PAGE;
    const search = params.get("search") || "";
    const size = params.get("pageSize") || "";

    if (prevPage !== page || prevSearch !== search || prevParams.get("search") !== params.get("search") || prevSize !== size) {
      this.setState({ currentPage: page, search }, () => {
        this.props.getCustomerNameApi(this);

      });
    }
  }


  clearSearch = () => {
    this.onChangeMethod({ search: "" })
  }

  onChangeMethod = (value) => {
    this.setState({ searchText: value.search, currentPage: START_PAGE }, () => {
      replaceHistory(this.props.history, START_PAGE, value.search)
    })
  }

  getDetailsUser = (id) => {

    this.props.history({ pathname: `/ads-customer-details/${id}`, state: { "id": id } });
  }

  getSsoPartnerDetails = (id) => {
    const type = sessionStorage.setItem("type", "admin-web-user")
    this.props.history({ pathname: `/sso/web-user/details/0/${id}`, state: { "id": id, "type": "admin-web-user" } });

  }

  openCloseDeleteModal = (rowData) => {
    this.setState({
      delete: !this.state.delete,
      deleteData: rowData || {},
    });
  };

  deleteHandle = (id) => {
    deleteCustomerApi(id, this);
  };

  getCustomerName = (customer = {}) => {
    return `${customer.firstName || ""} ${customer.lastName || ""}`.trim() || customer.emailAddress || "this customer";
  };



  render() {

    const { customerList, totalPages, currentPage } = this.props.customersState;
    const { detailLoading, access } = this.state;
    return (
      <>
        {this.state.delete && (
          <InformationModal
            show={this.state.delete}
            id={this.state.deleteData?.uuid}
            title={`Are you sure you want to delete ${this.getCustomerName(this.state.deleteData)}?`}
            handleClose={this.openCloseDeleteModal}
            handleDelete={this.deleteHandle}
          />
        )}

        <section className="request-section">
          <ComponentHeader
            title="Customers"
            breadcrumb={[["Customers", ""]]}
            isSearch={true}
            placeholder={"Search Customer"}
            onChangeMethod={this.onChangeMethod}
            clearSearch={() => this.clearSearch()}
          />
          {detailLoading ?
            <div className="inter-medium f-s-18 lh-22 text-center py-5 d-flex align-items-center justify-content-center gap-12"> <Spinner classes={'black-border'} /> Loading...</div>
            :
            <div className="commom-table-wrapper">
              <CustomTable
                ctx={this}
                data={customerList?.list || []}
                columns={[

                  {
                    width: 200,
                    title: "Full Name",
                    dataIndex: "firstName",

                    className: "name",
                    isCell: true,
                    render: (text, rowData, dataKey) => {
                      const firstName = rowData.firstName ?? "";
                      const lastName = rowData.lastName ?? "";
                      return `${firstName} ${lastName}`.trim();
                    },
                  },
                  {
                    width: 250,
                    title: "Email Id",
                    dataIndex: "emailAddress",
                    className: "name",
                    isCell: true,
                    render: (text, rowData, dataKey) => {
                      return rowData.emailAddress || 'Na';
                    },
                  },

                  {
                    width: 250,
                    title: "Mobile Number",
                    dataIndex: "mobileNumber",
                    className: "name",
                    isCell: true,
                    render: (text, rowData, dataKey) => {
                      return rowData.mobileNumber || 'Na';
                    },
                  },
                  {
                    width: 250,
                    title: "Company Name",
                    dataIndex: "companyName",
                    className: "name",
                    isCell: true,
                    render: (text, rowData, dataKey) => {
                      return rowData.companyName || 'Na';
                    },
                  },
                  {
                    width: 300,
                    title: "SSO Partner Name",
                    dataIndex: "ssoPartnerName",
                    className: "name",
                    isCell: true,
                    render: (text, rowData, dataKey) => {
                      return rowData.ssoPartnerName;
                    },
                  },
                  {
                    width: 100,
                    title: "Is Premium",
                    dataIndex: "isPremium",
                    className: "name",
                    isCell: true,
                    render: (text, rowData, dataKey) => {
                      return rowData?.isPremium ? "Yes" : "No";
                    },
                  },
                  // {
                  //   width: 100,
                  //   title: "Liked",
                  //   dataIndex: "userActivities",
                  //   className: "activities",
                  //   isCell: true,
                  //   render:(text, rowData, dataKey) => {
                  //     if (dataKey === "userActivities" && Array.isArray(rowData?.userActivities)) {
                  //       const likedCount = rowData?.userActivities?.filter(activity => activity?.type === "Liked").length;
                  //       return likedCount > 0 ? likedCount : '0';
                  //     }
                  //     return '0';
                  //   },
                  // },
                  // {
                  //   width: 100,
                  //   title: "Shared",
                  //   dataIndex: "userActivities",
                  //   className: "activities",
                  //   isCell: true,
                  //   render:(text, rowData, dataKey) => {
                  //     if (dataKey === "userActivities" && Array.isArray(rowData?.userActivities)) {

                  //       const sharedCount = rowData?.userActivities?.filter(activity => activity?.type === "Shared").length;
                  //       return sharedCount > 0 ? sharedCount : '0';
                  //     }
                  //     return '0';
                  //   },
                  // },
                  // {
                  //   width: 150,
                  //   title: "Downloaded",
                  //   dataIndex: "userActivities",
                  //   className: "activities",
                  //   isCell: true,
                  //   render:(text, rowData, dataKey) => {
                  //     if (dataKey === "userActivities" && Array.isArray(rowData?.userActivities)) {

                  //       const downloadCount = rowData?.userActivities?.filter(activity => activity?.type === "Downloaded").length;
                  //       return downloadCount > 0 ? downloadCount : '0';
                  //     }
                  //     return '0';
                  //   },
                  // },
                  // {
                  //   width: 150,
                  //   title: "Cobrand",
                  //   dataIndex: "userActivities",
                  //   className: "activities",
                  //   isCell: true,
                  //   render:(text, rowData, dataKey) => {
                  //     if (dataKey === "userActivities" && Array.isArray(rowData?.userActivities)) {

                  //       const cobrandCount = rowData?.userActivities?.filter(activity => activity?.type === "Cobrand").length;
                  //       return cobrandCount > 0 ? cobrandCount : '0';
                  //     }
                  //     return '0';
                  //   },
                  // },
                  {
                    width: 150,
                    title: "Registered Date",
                    dataIndex: "createdAt",
                    className: "activities",
                    isCell: true,
                    render: (text, rowData, dataKey) => {
                      return moment(rowData?.createdAt * 1000).format('lll') || '-';
                    },
                  },
                  {
                    width: 150,
                    title: "Next Payment Date",
                    dataIndex: "nextBillingDate",
                    className: "activities",
                    isCell: true,
                    render: (text, rowData, dataKey) => {
                      return rowData?.nextBillingDate ? moment(rowData?.nextBillingDate).format('lll') : '-';
                    },
                  },

                  {
                    width: 20,
                    title: "Action",
                    dataIndex: "",
                    fixed: "right",
                    className: "",
                    isCell: true,
                    render: (text, rowData, dataKey) => {
                      return (


                        <OptionsDropdown
                          viewHandler={() => {
                            if (rowData?.sso_partner_id) {
                              this.getSsoPartnerDetails(rowData?.id);
                            } else {
                              this.getDetailsUser(rowData?.uuid);
                            }
                          }}
                          deleteHandler={
                            access.deleteAccess
                              ? () => {
                                  this.openCloseDeleteModal(rowData);
                                }
                              : null
                          }
                        />

                      );
                    },
                  },

                ]}

                total={customerList?.length || 0}
                currentPage={currentPage}
                loading={this.state.isLoading}
              />
            </div>
          }
        </section>
      </>
    );
  }
}


const mapStateToProps = state => ({
  customersState: state.CustomersState,
});
const mapDispatchToProps = {
  getCustomerNameApi

};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Customers));

